// The Bayes Price skill level (#2021, 31 Oct 2026): a group of skills that
// every customer's chats have, which a customer can read and duplicate, and
// which Bayes Price can turn off per customer. It stays on Admin → Skills and
// only talks: it never duplicates, moves, turns off or saves a skill, since
// each one changes what chats receive.

import type { Walkthrough } from './types'

export const bayesPriceSkills: Walkthrough = {
  slug: 'bayes-price-skills',
  title: 'Bayes Price skills',
  summary:
    'Shows the Bayes Price group in the skills library: what a customer sees, how Duplicate works, what the labels mean and what a Bayes Price Manager can do. Nothing is duplicated, moved, turned off or saved.',
  issue: '#2021',
  added: '2026-10-31',
  steps: [
    {
      page: 'admin-agent-skills',
      feature: 'skills/bayes-price-skills',
      say: 'The skills library has a new group, Bayes Price. These are skills Bayes Price keeps for every customer. Each one carries a Bayes Price chip and a line saying when that version was saved.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/bayes-price-skills',
      say: 'Every chat of every customer has these skills without anyone installing them. For a customer’s people they are read only: Edit and Delete are greyed, and the reason says that only Bayes Price can change the skill.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/duplicate-bayes-price-skill',
      say: 'To change one, use Duplicate in the row’s menu. Duplicate to My skills makes your own copy with the same name, so your chats use your copy instead. Duplicate to Company-level does the same for the whole customer, and is greyed unless you are a Manager.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/duplicate-bayes-price-skill',
      say: 'When Bayes Price saves a newer version of the original, your copy shows the chip Bayes Price has a newer version. Your copy keeps its old content until you decide what to do.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/bayes-price-skills',
      say: 'Two more labels explain a Bayes Price skill that is not in your chats. Off for your organisation means Bayes Price turned it off for this customer, and the row is greyed. Your Company-level skill of this name is used instead, or Your skill of this name is used instead, means a skill you made with the same name wins.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/turn-off-for-customer',
      say: 'For a Bayes Price Manager the same menu has Turn off for this customer, and Turn on to undo it. Customers’ people never see those options. I have not used them here.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/move-to-bayes-price',
      say: 'A Manager also moves a saved skill here with Move to Bayes Price skills, which asks to confirm. And a draft that has the name of a Bayes Price skill can be saved over it with Save to Bayes Price skills in the editor. Nothing is moved or saved in this walkthrough.',
    },
  ],
}
